import { Component, inject, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OuiButton } from 'omnium-ui/button';
import { OuiDialogModule } from 'omnium-ui/dialog';
import { OuiRadioButton, OuiRadioList } from 'omnium-ui/form-field';
import { OuiIconModule } from 'omnium-ui/icon';
import { CommissionAdiType } from '@lib/models/commission-adi.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RenouvellementService } from '../../../_shared/services/renouvellement/renouvellement.service';
import { OuiLoading } from 'omnium-ui/loading';
import { OuiSnackbarService } from 'omnium-ui/snackbar';

@Component({
  selector: 'app-commission-adi-dialog',
  standalone: true,
  imports: [
    OuiDialogModule,
    OuiButton,
    OuiIconModule,
    OuiRadioList,
    OuiRadioButton,
    OuiLoading,
  ],
  templateUrl: './commission-adi-dialog.component.html',
  styleUrl: './commission-adi-dialog.component.scss',
})
export class CommissionAdiDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<CommissionAdiDialogComponent>);
  private readonly renouvellementService = inject(RenouvellementService);
  private readonly snackbarService = inject(OuiSnackbarService);

  readonly data = inject(MAT_DIALOG_DATA);
  readonly isLoading = signal<boolean>(false);

  readonly commissionAdiControl = new FormControl<CommissionAdiType>(
    this.data.actuelCommissionAdi,
    {
      nonNullable: false,
    }
  );

  async saveRenouvellementComAdi() {
    try {
      this.isLoading.set(true);
      await this.renouvellementService.saveRenouvellementComAdi(
        this.commissionAdiControl.value!
      );
      this.snackbarService.open(
        'Votre choix de commission ADI a bien été pris en compte',
        'success'
      );
      this.dialogRef.close();
    } catch (error) {
      console.error(error);
      this.snackbarService.open(
        'Une erreur est survenue durant la validation du renouvellement.',
        'error'
      );
    }

    this.isLoading.set(false);
  }
}
